import * as $runtime from "../runtime.js";
import * as Data$dDateTime from "../Data.DateTime/index.js";
import * as Data$dDateTime$dInstant from "../Data.DateTime.Instant/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dJSDate from "../Data.JSDate/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Effect$dNow from "../Effect.Now/index.js";
import * as Restaumatic$dCurrencies from "../Restaumatic.Currencies/index.js";
import {_formatCurrency} from "./foreign.js";
const isHrkEurEnabled = () => {
  const v = Effect$dNow.nowDateTime();
  const $0 = Data$dJSDate.toInstant(Data$dJSDate.jsdate({year: 2022.0, month: 8.0, day: 1.0, hour: 0.0, minute: 0.0, second: 0.0, millisecond: 0.0}));
  if ($0.tag === "Just") { return !(Data$dDateTime.ordDateTime.compare(v)(Data$dDateTime$dInstant.toDateTime($0._1)).tag === "LT"); }
  return false;
};
const isEurHrkEnabled = () => {
  const v = Effect$dNow.nowDateTime();
  const $0 = Data$dJSDate.toInstant(Data$dJSDate.jsdate({year: 2023.0, month: 0.0, day: 1.0, hour: 0.0, minute: 0.0, second: 0.0, millisecond: 0.0}));
  if ($0.tag === "Just") { return !(Data$dDateTime.ordDateTime.compare(v)(Data$dDateTime$dInstant.toDateTime($0._1)).tag === "LT"); }
  return false;
};
const hrkDualPricesEnabledRef = {value: false};
const isHrkDualPricesEnabled = () => hrkDualPricesEnabledRef.value;
const setHrkDualPricesEnabled = b => () => hrkDualPricesEnabledRef.value = b;
const withHrkDualPricesEnabled = b => computation => {
  const previous = isHrkDualPricesEnabled();
  const u = hrkDualPricesEnabledRef.value = b;
  hrkDualPricesEnabledRef.value = previous;
  return computation(u);
};
const currencyOptions = v => {
  if (v.tag === "PLN") { return {format: "%n %u", precision: 2, separator: ",", delimiter: " ", unit: "zł"}; }
  if (v.tag === "CZK") { return {format: "%n %u", precision: 2, separator: ",", delimiter: "", unit: "Kč"}; }
  if (v.tag === "GBP") { return {format: "%u%n", precision: 2, separator: ".", delimiter: ",", unit: "£"}; }
  if (v.tag === "USD") { return {format: "%u%n", precision: 2, separator: ".", delimiter: "", unit: "$"}; }
  if (v.tag === "EUR") { return {format: "%n %u", precision: 2, separator: ",", delimiter: "", unit: "EUR"}; }
  if (v.tag === "RUB") { return {format: "%n %u", precision: 2, separator: ",", delimiter: " ", unit: "руб."}; }
  if (v.tag === "RON") { return {format: "%n %u", precision: 2, separator: ",", delimiter: " ", unit: "RON"}; }
  if (v.tag === "HRK") { return {format: "%n %u", precision: 2, separator: ",", delimiter: " ", unit: "kn"}; }
  if (v.tag === "BRL") { return {format: "%u%n", precision: 2, separator: ".", delimiter: "", unit: "R$"}; }
  $runtime.fail();
};
const currencyUnit = x => currencyOptions(x).unit;
const formatCurrency = v => v1 => {
  if (v.tag === "HRK") {
    if (isHrkDualPricesEnabled() && isHrkEurEnabled()) {
      return _formatCurrency(currencyOptions(Restaumatic$dCurrencies.HRK), Data$dInt.toNumber(v1) / 100.0) + " (" + _formatCurrency(
        currencyOptions(Restaumatic$dCurrencies.EUR),
        Data$dInt.toNumber(Data$dMoney$dRounded.roundCents(Data$dInt.toNumber(v1) / 7.5345)) / 100.0
      ) + ")";
    }
    return _formatCurrency(currencyOptions(v), Data$dInt.toNumber(v1) / 100.0);
  }
  if (v.tag === "EUR") {
    if (isHrkDualPricesEnabled() && isEurHrkEnabled()) {
      return _formatCurrency(currencyOptions(Restaumatic$dCurrencies.EUR), Data$dInt.toNumber(v1) / 100.0) + " (" + _formatCurrency(
        currencyOptions(Restaumatic$dCurrencies.HRK),
        Data$dInt.toNumber(Data$dMoney$dRounded.roundCents(Data$dInt.toNumber(v1) * 7.5345)) / 100.0
      ) + ")";
    }
    return _formatCurrency(currencyOptions(v), Data$dInt.toNumber(v1) / 100.0);
  }
  return _formatCurrency(currencyOptions(v), Data$dInt.toNumber(v1) / 100.0);
};
export {
  currencyOptions,
  currencyUnit,
  formatCurrency,
  hrkDualPricesEnabledRef,
  isEurHrkEnabled,
  isHrkDualPricesEnabled,
  isHrkEurEnabled,
  setHrkDualPricesEnabled,
  withHrkDualPricesEnabled
};
export * from "./foreign.js";
